import { computed, ref, toValue, type ComputedRef, type MaybeRefOrGetter, type Ref } from 'vue';

import type { CollectionsBlockItem } from './phxsg-collections-block.vue';

const MAX_THUMBNAILS = 4;

export interface UseThumbnailSwapReturn {
  currentIndex: Ref<number>;
  currentItem: ComputedRef<CollectionsBlockItem>;
  thumbnailIndexes: Ref<number[]>;
  swapWithCurrent: (clickedIndex: number) => void;
}

export function useThumbnailSwap(items: MaybeRefOrGetter<CollectionsBlockItem[]>): UseThumbnailSwapReturn {
  const currentIndex = ref(0);
  const thumbnailIndexes = ref(
    toValue(items)
      .map((_, index) => index)
      .filter((index) => index !== currentIndex.value)
      .slice(0, MAX_THUMBNAILS),
  );

  const currentItem = computed(() => toValue(items)[currentIndex.value]);

  function swapWithCurrent(clickedIndex: number): void {
    const previousIndex = currentIndex.value;
    currentIndex.value = clickedIndex;

    thumbnailIndexes.value = thumbnailIndexes.value.map((index) => (index === clickedIndex ? previousIndex : index));
  }

  return { currentIndex, currentItem, thumbnailIndexes, swapWithCurrent };
}
